import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
TableBody.defaultProps = {};
/**
 * maoui Styled Table Body
 *
 * @param {StyledProps} props - children
 * @example
 * <TableBody id="">
 * 	{children}
 * </TableBody>
 * @returns React.ReactElement
 */
export default function TableBody(props) { return (_jsx(StyledComponent, __assign({}, props))); }
;
